import React, { PropTypes } from 'react';
import { Dialog, FlatButton, FontIcon } from 'material-ui';

const SubmitDialog = props => {
  const {
    dispatchedUpdateProps,
    showExistingCompanyDialog,
    goToConfirmationPage,
    companyName,
    submitSignUpAction,
    companyTypeChecked,
    selectedCompanyType,
    acctCreationReason,
    country,
    email,
    password,
    oneOrMultiProperties,
    numOfProperties,
    oneOrMultiCities,
    existingCompanyId,
    region,
  } = props;

  const actions = [
    <FlatButton
      label="Cancel"
      primary
      onTouchTap={() => dispatchedUpdateProps({
        showExistingCompanyDialog: false,
        showFoundExistingCompanyInfo: false,
      })}
    />,
    <FlatButton
      label="Ok"
      secondary
      onTouchTap={() => {
        submitSignUpAction({
          companyTypeChecked,
          selectedCompanyType,
          acctCreationReason,
          country,
          companyName,
          email,
          password,
          oneOrMultiProperties,
          numOfProperties,
          oneOrMultiCities,
          existingCompanyId,
          region,
        }).then(() => goToConfirmationPage());
      }}
    />,
  ];

  return (
    <div>
      <Dialog
        actions={actions}
        modal
        open={showExistingCompanyDialog}
        onRequestClose={() => dispatchedUpdateProps({
          showExistingCompanyDialog: false,
          showFoundExistingCompanyInfo: false,
        })}
        contentStyle={{ width: '500px' }}
      >
      <div className="Grid">
        <div style={{ float: 'left' }} className="Grid-cell Grid-cell--center">
          <FontIcon
            className="tc-icon-warning"
            color={'rgb(255, 64, 129)'}
            style={{ fontSize: '50px' }}
          />
        </div>
        <div style={{ float: 'right', width: '80%' }}>
          <p style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' }}>
            You have selected a company that already exists.
          </p>
          <p style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)' }}>
            By continuing, you understand the administrator of {companyName} will need to
            confirm your account before you can log in.
          </p>
        </div>
      </div>
      </Dialog>
    </div>
  );
};

SubmitDialog.propTypes = {
  dispatchedUpdateProps: PropTypes.func,
  showExistingCompanyDialog: PropTypes.bool,
  goToConfirmationPage: PropTypes.func,
  companyName: PropTypes.string,
  submitSignUpAction: PropTypes.func,
  companyTypeChecked: PropTypes.array,
  selectedCompanyType: PropTypes.string,
  acctCreationReason: PropTypes.string,
  country: PropTypes.string,
  email: PropTypes.string,
  password: PropTypes.string,
  oneOrMultiProperties: PropTypes.string,
  numOfProperties: PropTypes.string,
  oneOrMultiCities: PropTypes.string,
  existingCompanyId: PropTypes.string,
  region: PropTypes.string,
};

export default SubmitDialog;



// WEBPACK FOOTER //
// ./src/app/components/signup/form/existing-company-dialog.jsx